import { localStorageHasItem } from '#/utils/localStorage';

let cachedBlob: Blob | null = null;
const fetchMockImageFile = async (): Promise<Blob> => {
  if (cachedBlob) return cachedBlob;

  const response = await fetch('/static/images/tools.jpg');
  const blob = await response.blob();
  cachedBlob = blob;
  return blob;
};

export const getMockFile = async (): Promise<File> => {
  const useSVG = localStorageHasItem('filestackMockSVG');
  const filename = useSVG ? 'image.svg' : 'image.jpg';
  const mimetype = useSVG ? 'image/svg+xml' : 'image/jpeg';

  // NOTE: we don't need to pass any svg files here as the only place where we
  // transform the file is the crop modal. The modal supports only raster
  // formats now.
  if (useSVG) return new File([''], filename, { type: mimetype });

  return new File([await fetchMockImageFile()], filename, { type: mimetype });
};
